module.exports = __webpack_public_path__ + "static/media/stage_active.3238518b.svg";